import { DateTime } from "luxon";

export function convertToSlug(text: string) {
  return text.toLowerCase().replace(/\s+/g, "-").trim();
}

export function convertToTitle(slug: string) {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function extractAndUppercaseFirstWord(text: string) {
  if (!text) return "";
  const firstWord = text.split(/[-_]/)[0];
  return firstWord.toUpperCase();
}

export function convertToSnakeCase(text: string) {
  if (!text) return "";
  return text.includes(" ") ? text.split(" ").join("_") : text;
}

export const getFYMonths = () => {
  const today = DateTime.now();
  const start = DateTime.local(2025, 4, 1); // FY 2025 starts April 2025

  const diffMonths = today.diff(start, "months").months;
  const months: {
    label: string;
    value: string;
    startDate: string;
    endDate: string;
  }[] = [];

  for (let i = 0; i <= diffMonths; i++) {
    const monthDate = today.minus({ months: i });
    const startDate = monthDate.startOf("month").toISODate();

    const endDate = monthDate.hasSame(today, "month")
      ? today.toISODate()
      : monthDate.endOf("month").toISODate();

      months.push({
      label: monthDate.toFormat("MMMM yyyy"),
      value: monthDate.toFormat("yyyy-MM"),
      startDate,
      endDate,
    });
  }

  return months.reverse();
};
